const BANK_CASE_STATUSES = [
  { text: 'New', value: 'new', name: 'new', color: 'status-info' },
  { text: 'Pending Docs', value: 'pending_docs', name: 'pending_docs', color: 'status-warning' },
  { text: 'Docs Submitted', value: 'pending_docs_submitted', name: 'pending_docs_submitted', color: 'status-warning' },
  { text: 'LO Issued', value: 'approved_lo_issued', name: 'approved_lo_issued', color: 'status-good' },
  { text: 'Unreachable', value: 'pending_unreachable', name: 'pending_unreachable' },
  { text: 'Loan Re-appealed', value: 'pending_reappealed', name: 'pending_reappealed' },
  { text: 'Wrong Info', value: 'reject_wrong_info', name: 'reject_wrong_info' },
  { text: 'Customer Cancelled', value: 'reject_cancelled', name: 'reject_cancelled', color: 'status-danger' },
  { text: 'LO Signed', value: 'success_li_issued', name: 'success_li_issued', color: 'status-good' },
  { text: 'Unqualified', value: 'reject_unqualified', name: 'reject_unqualified', color: 'status-danger' },
  { text: 'Loan Rejected', value: 'reject_bank', name: 'reject_bank', color: 'status-danger' },
  { text: 'Customer Rejected', value: 'reject_customer', name: 'reject_customer', color: 'status-danger' },
  { text: 'LO Signed With Another Bank', value: 'reject_lo_signed_other_bank', name: 'reject_lo_signed_other_bank', color: 'status-danger' },
  { text: 'Developer Cancelled', value: 'reject_developer', name: 'reject_developer', color: 'status-danger' },
];
export const BANK_CASE_STATUS_GROUPS = [
  { text: 'All', value: 'all', name: 'all' },
  { text: 'Current', value: 'current', name: 'current' },
  { text: 'Closed', value: 'closed', name: 'closed' },
  { text: 'Custom', value: 'custom', name: 'custom' },
];
export const CURRENT_STATUSES = [
  'new',
  'pending_docs',
  'pending_docs_submitted',
  'approved_lo_issued',
  'pending_unreachable',
  'pending_reappealed',
  'reject_wrong_info',
  'reject_cancelled',
];
export const CLOSED_STATUSES = [
  'success_li_issued',
  'reject_unqualified',
  'reject_bank',
  'reject_customer',
  'reject_lo_signed_other_bank',
  'reject_developer',
];
export const REJECTED_STATUSES = [
  'reject_cancelled',
  'reject_unqualified',
  'reject_bank',
  'reject_customer',
  'reject_lo_signed_other_bank',
  'reject_developer',
];
export default BANK_CASE_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/bankCaseStatuses.js